import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DeliveryPlan } from '../../../models/delivery-plan.model';

@Component({
  standalone: false,
  selector: 'app-packing-details-modal',
  templateUrl: './packing-details.component.html',
  styleUrls: ['../modal.component.scss']
})

export class PackingDetailsModalComponent implements OnInit {
  @Input() cargo?: DeliveryPlan | null;
  packingForm!: FormGroup;
  @Output() readonly responseChanged = new EventEmitter();

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.initForm();

     if (this.cargo) {
      this.packingForm.patchValue(this.cargo);
     }
  }

  initForm(): void {
    this.packingForm = this.fb.group({
      numberOfPackages: [0, Validators.required],
      numberOfPallets: [0, Validators.required],
      numberOfRowsPerPallet: [0, Validators.required],
      numberOfPackagesInRow: [0, Validators.required],
      grossWeight: [0, Validators.required],
      netWeight: [0, Validators.required],
    });
  }

  emitFalse(): void {
    this.responseChanged.emit(false);
  }

  emitTrue(): void {
    this.responseChanged.emit(this.packingForm.value);
  }
}